/* eslint-disable @typescript-eslint/no-unused-vars */
import Vue from 'vue';

const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const MONTH = DAY * 30;
const YEAR = MONTH * 12;
const IN_MILLISECONDS = 1000;

function calculateTimeFromNow(time: number, shortText = false, hoursOnly = false) {
    const secs = Math.abs(Math.floor(time % MINUTE));
    const minutes = Math.abs(Math.floor((time % HOUR) / MINUTE));
    const hours = Math.abs(Math.floor((time % DAY) / HOUR));
    const days = Math.abs(Math.floor(time / DAY));

    if (!days && !hours && !minutes) {
        return 'Now';
    }

    let ss = '';
    if (days) ss = ss + days + (shortText ? 'd' : ' Day(s) ');
    if (hours || hoursOnly) ss = ss + hours + (shortText ? 'h' : ' Hour(s) ');
    if (!hoursOnly) {
        if (minutes) ss = ss + minutes + (shortText ? 'm' : ' Minute(s) ');
        if (secs && !days && !hours && minutes) {
            ss = ss + secs + (shortText ? 's' : ' Second(s)');
        }
    }

    return ss + ' ago.';
}

Vue.filter('fromNow', calculateTimeFromNow);
